export const KEEPER_ROLE_LABELS = {
  owner: 'Pemilik Kos',
  keeper: 'Penjaga Kos',
};

// Maps notification-setting-type API values to Indonesian display labels.
// Unmapped values fall back to the API label (see notificationTypeLabel).
export const NOTIFICATION_TYPE_LABELS = {
  survey: 'Survei',
  new_booking: 'Pembayaran DP',
  settlement: 'Pelunasan',
  full_payment: 'Pembayaran Penuh',
  checkout: 'Check-out',
};

export const keeperRoleLabel = role => KEEPER_ROLE_LABELS[role] || role || '-';

export const notificationTypeLabel = (value, fallback = '') =>
  NOTIFICATION_TYPE_LABELS[value] || fallback || value;
